import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useSendAccessFormSchema = () => {
  const { t } = useTranslation("order", {
    keyPrefix: "orderListPage.sendAccessModal.validations"
  });

  const schema = useMemo(
    () =>
      z.object({
        credentials: z
          .string()
          .refine((val) => val.replace(/<[^>]*>/g, "").trim().length > 0, {
            message: t("credentialsRequired")
          })
      }),
    [t]
  );

  return schema;
};

export type SendAccessFormSchema = z.infer<
  ReturnType<typeof useSendAccessFormSchema>
>;
